import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "preferential_body"
};
const _hoisted_2 = {
  class: "preferential_body_nr"
};
const _hoisted_3 = {
  class: "preferential_tab"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "preferential_list"
};
const _hoisted_6 = {
  class: "item_top"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  style: {
    "font-size": "100px",
    "font-weight": "bold"
  }
};
const _hoisted_9 = {
  key: 1,
  class: "case"
};
const _hoisted_10 = {
  style: {
    "font-size": "100px",
    "font-weight": "bold"
  }
};
const _hoisted_11 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/yhj/ysy.png",
  alt: "",
  class: "ztIcon"
};
const _hoisted_14 = {
  key: 1,
  src: "https://www.mimodental.com/assets/imgData/img/yhj/ygq.png",
  alt: "",
  class: "ztIcon"
};
const _hoisted_15 = {
  key: 1,
  style: {
    "display": "flex",
    "width": "100%",
    "align-items": "center",
    "justify-content": "center"
  }
};
const _hoisted_16 = {
  class: "dialog_body"
};
const _hoisted_17 = {
  class: "dialog_info"
};
const _hoisted_18 = {
  class: "info_name"
};
const _hoisted_19 = {
  class: "l"
};
const _hoisted_20 = {
  class: "info_code"
};
const _hoisted_21 = {
  class: "dialog_tip"
};
const _hoisted_22 = {
  style: {
    "margin-top": "10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vue_qr = _resolveComponent("vue-qr");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("h1", null, "优惠券", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.preferential_tab, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: _normalizeStyle('color:' + ($setup.preferential_tab_key == item.key ? '#27A9C6;' : '#000;')),
      onClick: $event => $setup.preferential_tab_click(item.key)
    }, _toDisplayString(item.name), 13, _hoisted_4);
  }), 128))]), _createElementVNode("div", _hoisted_5, [$setup.cardRecordsList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($setup.cardRecordsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", {
      style: _normalizeStyle('background:' + ($setup.designsObj[item.cardId]?.background ? 'url(' + $setup.designsObj[item.cardId].background + ');' : $setup.preferential_tab_key == 1 ? '#E7F6F9;' : '#E6E6E6;'))
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
      style: _normalizeStyle('color:' + ($setup.designsObj[item.cardId]?.titleColor ? $setup.designsObj[item.cardId]?.titleColor : $setup.preferential_tab_key == 1 ? '#13A4BF;' : '#737373;'))
    }, [item.cardType == 'discount' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.discount), 1), _cache[1] || (_cache[1] = _createElementVNode("h1", {
      style: {
        "font-size": "24px",
        "margin-left": "7px",
        "display": "inline-block"
      }
    }, "折", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[2] || (_cache[2] = _createElementVNode("span", {
      style: {
        "font-size": "40px"
      }
    }, "￥", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(item.reduceCost), 1)]))], 4), _createElementVNode("h3", {
      style: _normalizeStyle('color:' + ($setup.designsObj[item.cardId]?.dateColor ? $setup.designsObj[item.cardId]?.dateColor : $setup.preferential_tab_key == 1 ? '#000;' : '#A2A2A2;'))
    }, " 有效期：" + _toDisplayString(item.endDateStr), 5)]), _createElementVNode("div", {
      class: "item_bot",
      style: _normalizeStyle('background:' + ($setup.designsObj[item.cardId] ? 'none;' : $setup.preferential_tab_key == 1 ? '#F3FAFC;' : '#F2F2F2;'))
    }, [_createElementVNode("div", {
      style: _normalizeStyle([{
        "width": "90%",
        "display": "flex",
        "flex-direction": "column",
        "font-size": "16px",
        "position": "absolute",
        "top": "10px"
      }, 'color:' + ($setup.designsObj[item.cardId]?.dateColor || '#000')])
    }, [_createElementVNode("span", _hoisted_11, [_cache[3] || (_cache[3] = _createTextVNode("劵码：", -1)), _createElementVNode("span", null, _toDisplayString(item.code), 1)])], 4), $setup.preferential_tab_key == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "btn",
      onClick: $event => $setup.show_dialog(item.id),
      style: _normalizeStyle('background:' + ($setup.designsObj[item.cardId]?.btnColor || '#13A4BF'))
    }, " 使用 ", 12, _hoisted_12)) : _createCommentVNode("", true)], 4)], 4), $setup.preferential_tab_key == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : _createCommentVNode("", true), $setup.preferential_tab_key == 5 ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : _createCommentVNode("", true)]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[4] || (_cache[4] = [_createElementVNode("img", {
    style: {
      "width": "347px"
    },
    src: "https://www.mimodental.com/assets/imgData/img/member_preferential/empty.png"
  }, null, -1)])))])]), _createVNode(_component_el_dialog, {
    modelValue: $setup.show,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.show = $event),
    width: "35%",
    "align-center": "",
    style: {
      "border-radius": "10px",
      "overflow": "hidden",
      "min-width": "530px"
    },
    "before-close": $setup.handleClose
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_cache[14] || (_cache[14] = _createElementVNode("h1", null, "券核销", -1)), _cache[15] || (_cache[15] = _createElementVNode("div", {
      class: "state"
    }, [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/img/member_preferential/time.png",
      alt: ""
    }), _createElementVNode("span", null, "待到店使用")], -1)), _createElementVNode("div", null, [_createElementVNode("span", null, "请在" + _toDisplayString($setup.dialog_data.endDateStr) + "前到店使用", 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", null, "券码信息（" + _toDisplayString($setup.dialog_data.title) + "）", 1), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_19, [_cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "dian"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString($setup.dialog_data.code), 1)]), _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "r"
    }, [_createElementVNode("span", null, "待使用")], -1))])]), _cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "xian",
      style: {
        "height": "100px"
      }
    }, null, -1)), _createElementVNode("div", _hoisted_20, [_createVNode(_component_vue_qr, {
      logoSrc: require('../../../public/smalllogo.png'),
      text: $setup.dialog_data.code,
      size: "1000"
    }, null, 8, ["logoSrc", "text"])])]), _cache[16] || (_cache[16] = _createElementVNode("div", {
      class: "dialog_address"
    }, [_createElementVNode("div", null, [_createElementVNode("span", null, "米檬口腔（珠江新城店）"), _createElementVNode("div", null, [_createElementVNode("span", null, "黄埔大道西高志大厦3楼")])]), _createElementVNode("div", {
      class: "xian",
      style: {
        "height": "50px"
      }
    }), _createElementVNode("div", null, [_createElementVNode("span", null, "米檬口腔（黄埔旗舰店）"), _createElementVNode("div", null, [_createElementVNode("span", null, "开创大道雪松中心103铺")])])], -1)), _cache[17] || (_cache[17] = _createElementVNode("div", {
      class: "dialog_address"
    }, [_createElementVNode("div", null, [_createElementVNode("span", null, "米檬口腔（番禺青春店）"), _createElementVNode("div", null, [_createElementVNode("span", null, "广州市番禺区钟村街文都二街6号(保利大都汇北侧)")])])], -1)), _createElementVNode("div", _hoisted_21, [_cache[13] || (_cache[13] = _createElementVNode("h3", null, "温馨提示", -1)), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, [_cache[9] || (_cache[9] = _createElementVNode("span", null, "有效期：", -1)), _createElementVNode("span", null, "有效期至" + _toDisplayString($setup.dialog_data.endDateStr) + "前使用", 1)]), _cache[11] || (_cache[11] = _createElementVNode("div", null, [_createElementVNode("span", null, "使用时间："), _createElementVNode("span", null, "营业时间内可用")], -1)), _cache[12] || (_cache[12] = _createElementVNode("div", null, [_createElementVNode("span", null, "使用范围："), _createElementVNode("span", null, "正畸项目")], -1)), _createElementVNode("div", null, [_cache[10] || (_cache[10] = _createElementVNode("span", null, "使用规则：", -1)), _createElementVNode("span", null, _toDisplayString($setup.dialog_data.description), 1)])])])])]),
    _: 1
  }, 8, ["modelValue", "before-close"])]);
}